module.exports = __webpack_public_path__ + "static/media/apagar.471730c3.svg";